// Footer Nav
function resizeHandler() {
    console.log("window resized");

    if ($(window).width() < 767) {
        console.log("window small than 600");

        $('.footer-nav ul').hide();
        $('.footer-nav ul').slideUp(200);
    } else {
        $('.footer-nav ul').show();
        $('.footer-nav-header').removeClass("expanded");
    }
}

resizeHandler();

$(window).resize(resizeHandler);

$('body').on('click', '.footer-nav-header', function () {
    if ($(window).width() < 767) {
        $(this).next().slideToggle(200);
        $(this).toggleClass("expanded");
    }
});